const fmtDays = (v) => (v == null ? "—" : `${Math.round(v)}d`);
const badge = (s) =>
  s === "FINAL" ? "bg-emerald-50 text-emerald-700" : s === "ACTIVE" ? "bg-amber-50 text-amber-700" : "bg-gray-100 text-gray-400";

// Per-WO Claim-to-Cash cycle performance card (reads claim.cycle_aging from the API).
export function CycleAging({ ca }) {
  if (!ca) return null;
  const rows = [
    ["Pre Order Aging", "Claim → Unit In", ca.pre_order],
    ["Repair Aging", "Unit In → Unit Out", ca.repair],
    ["Unbilled", "Unit Out → Invoice", ca.unbilled],
    ["Collection Aging", "Invoice → Paid", ca.collection],
  ];
  return (
    <div data-testid="cycle-aging" className="rounded-lg border border-gray-100 bg-white p-4 shadow-sm">
      <div className="flex items-center justify-between">
        <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-[#111827]">Claim to Cash</h3>
        <span data-testid="cycle-overall-status" className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${ca.overall_status === "FINAL" ? "bg-[#111827] text-[#3B82F6]" : "bg-amber-100 text-amber-700"}`}>{ca.overall_status}</span>
      </div>
      {ca.unbilled_warning && (
        <div data-testid="unbilled-warning" className="mt-2 rounded bg-amber-50 px-2 py-1 text-[11px] font-semibold text-amber-700">
          ⚠ UNBILLED {fmtDays(ca.unbilled?.days)} — Unit sudah keluar tetapi Invoice belum diterbitkan
        </div>
      )}
      <div className="mt-3 space-y-1.5">
        {rows.map(([labelTxt, sub, m]) => (
          <div key={labelTxt} className="flex items-center justify-between text-sm">
            <div><span className="font-medium text-gray-800">{labelTxt}</span> <span className="text-[11px] text-gray-400">{sub}</span></div>
            <div className="flex items-center gap-2">
              <span className="font-mono font-semibold text-gray-800">{fmtDays(m?.days)}</span>
              <span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${badge(m?.status)}`}>{m?.status === "NOT_STARTED" ? "—" : m?.status}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-3 flex items-center justify-between border-t border-gray-100 pt-3">
        <span className="font-heading text-sm font-bold text-[#111827]">TOTAL CYCLE</span>
        <div className="flex items-center gap-2">
          <span data-testid="cycle-total-days" className="font-mono text-base font-bold text-[#111827]">{fmtDays(ca.total?.days)}</span>
          <span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${badge(ca.total?.status)}`}>{ca.total?.status}</span>
        </div>
      </div>
    </div>
  );
}
